// extracted by mini-css-extract-plugin
export var addressMsg = "index-module--addressMsg--62da5";
export var body = "index-module--body--1a010";
export var currencySelector = "index-module--currencySelector--71131";
export var exchangeConfiguration = "index-module--exchangeConfiguration--3caeb";
export var partnershipMsg = "index-module--partnershipMsg--b929a";
export var root = "index-module--root--8e7a9";
export var topperIcon = "index-module--topperIcon--60c9e";